import AppIcons from '../icons';
import ToolbarIcons from '../icons/toolbar';
import React from 'react';

const ar = {
  splash: 'عش اللحظات السعيدة',
  folderPart: {
    menu: [
      { id: 0, name: 'رسائل', fileType: 'message' },
      { id: 1, name: 'الصور', fileType: 'image' },
      { id: 2, name: 'فيديو', fileType: 'video' },
      { id: 3, name: 'موسيقى', fileType: 'music' },
      { id: 4, name: 'الملفات', fileType: 'pdf,doc' },
      { id: 5, name: 'آخر', fileType: 'zip,rar' },
    ],
  },
  reload: 'إعادة تحميل التطبيق',
  signupText: 'اشتراك',
  offlineText: 'تحقق من اتصال الإنترنت',
  onlineStatus: 'حالة الاتصال',
  onlineStatusOn: 'حالتك على الإنترنت معطلة',
  onlineStatusOff: 'حالة الاتصال الخاصة بك معطلة.',
  darkMode: 'الوضع المظلم',
  darkModeOn: 'تم تمكين الوضع الداكن.',
  darkModeOff: 'تم تعطيل الوضع الداكن.',
  chatDemo: {
    you: 'أنت',
    yourText: 'خبر میدم بهت',
    contact: 'جسی',
    contactText:
      'لوريم إيبسوم أو المخطط هو نص تجريبي ولا معنى له في صناعة الطباعة وتخطيط الصفحات والتصميم الجرافيكي. مصمم جرافيك لهذا النص كعنصر',
  },
  settingModal: {
    menu: [
      // { id: 1, name: 'اختيار موضوع' },
      // { id: 2, name: 'اللغات' },
      // { id: 3, name: 'خلفية' },
      {
        id: 1,
        name: 'يتغير موضوع',
        icon: (
          <ToolbarIcons.themeIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 2,
        name: 'اللغات',
        icon: (
          <ToolbarIcons.LanguageIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 3,
        name: 'خلفية',
        icon: (
          <ToolbarIcons.backgroundIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 4,
        name: 'ملف',
        icon: (
          <ToolbarIcons.FileIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 5,
        name: 'تعديل الملف الشخصي',
        icon: (
          <ToolbarIcons.EditProfileIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 8,
        name: 'تغيير كلمة المرور',
        icon: (
          <ToolbarIcons.changePasswordIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'18px'}
            height={'18px'}
          />
        ),
      },
      {
        id: 6,
        name: 'غادر المجموعة',
        icon: (
          <ToolbarIcons.ExitIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 7,
        name: 'حذف الحساب',
        icon: (
          <ToolbarIcons.DeleteAccount
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
    ],
  },
  deleteAccount: {
    title: '',
    description: 'هل انت متأكد انك تريد حذف حسابك؟',
    confirmText: 'نعم',
    rejectText: 'لا',
  },
  deleteFav: {
    title: '',
    description: 'هل أنت متأكد أنك تريد حذف الرسالة من قائمة المفضلة؟',
    confirmText: 'نعم',
    rejectText: 'لا',
  },
  // noContent: 'حدد المستخدم لبدء إرسال الرسائل.',
  noContent: 'اُچت ماسنجر في خدمتكم',
  startConversation: 'ابدأ المحادثة: ',
  startConversationTo: 'ابدأ المحادثة مع : ',
  conversation: 'محادثة',
  themeText: 'إعدادات',
  languages: 'اللغات',
  search: 'يبحث',
  errorRequired: 'هذه الخانة مطلوبه.',
  themeArray: [
    {
      color: 'white',
      // text: 'أبيض',
      text: 'لون القرنفل',
    },
    // { color: 'black', text: 'أسود' },
    { color: 'green', text: 'أخضر' },
    { color: 'blue', text: 'أزرق' },
  ],
  time: {
    some: 'قليلة',
    seconds: 'منذ ثوانى',
    minutes: 'قبل دقيقة',
    hours: 'منذ ساعة',
    days: 'اليوم السابق',
    weeks: ' الأسبوع الماضي',
    years: ' العام الماضي',
  },
  name: 'اُچت',
  description:
    'ادخل إلى تطبيق الدردشة الخاص بنا وافتح بُعدًا جديدًا للتواصل. الدردشة والتواصل وإنشاء محادثات لا تنسى.',
  appTitle: 'اُچت',
  login: {
    description: 'أدخل معلومات المستخدم الخاصة بك للدخول .',
    toSignup: {
      description: 'ليس لديك حساب في كليبشو؟',
      button: 'يسجل',
    },
    title: 'تسجيل الدخول',
    text: 'لاستخدام برنامج المراسلة، يرجى تسجيل الدخول إلى حسابك.',
    formButton: 'تسجيل الدخول',
    mobile: 'هاتف خلوي',
    mobileError: 'الهاتف المحمول غير صحيح',
    mobilePlaceHolder: '۹xxxxxxxx',
    password: 'كلمة المرور',
    passwordError: 'كلمة المرور غير صحيحة',
    forgetButton: 'نسيت كلمة السر؟',
    createAccount: {
      description:
        'سجل في اُچت لاستخدام مرافق اُچت مثل تحميل مقاطع الفيديو ، وترك التعليقات ، وما إلى ذلك.',
      title: 'تسجيل الدخول إلى اُچت',
      button: 'إنشاء حساب',
    },
  },
  replyToUser: 'الرد على',
  replyToMessage: 'الرد على هذه الرسالة',
  toolbar: {
    exit: 'مخرج',
    fileIcon: 'ملف',
    chatIcon: 'محادثة',
    theme: {
      title: 'اختيار موضوع',
    },
    language: {
      title: ' اختر اللغة',
    },
  },
  userDashboard: [
    {
      id: 1,
      name: 'رفع',
    },
    {
      id: 2,
      name: 'أشرطة فيديو',
    },
  ],
  chatPage: {
    you: 'أنت',
    navTitle: 'المستخدمين النشطين',
    footer: {
      InputPlaceHolder: 'رسالة نصية',
      notConnectText: 'قم بالتسجيل لنشر تعليقك.',
      sendButton: 'يُقدِّم',
      uploadButton: 'رفع',
    },
  },
  userMessage: {
    delete: 'تمت إزالته من المجموعة',
    left: 'ترك من المجموعة',
    add: 'تمت الإضافة إلى المجموعة',
  },
  chatFooter: {
    invalidType: 'ملف غير صالح',
    unBlock: 'رفع الحظر',
  },
  groupMember: {
    owner: 'مالك المجموعة',
  },
  groupMemberMore: [
    {
      id: 1,
      chosen: ' ترقية إلى ادمین',
      icon: <AppIcons.AdminIcon fill={'#000'} />,
      notChosen: 'صرف المشرف',
    },
    {
      id: 2,
      chosen: 'يمسح',
      icon: <AppIcons.deleteIcon fill={'#000'} />,
      notChosen: 'يمسح',
    },
  ],
  chatBar: {
    userMore: [
      {
        id: 1,
        chosen: 'دبوس',
        notChosen: 'نزع الدبوس',
        icon: <AppIcons.pinIconSetting fill={'#000'} className={`moreBox`} />,
      },
      {
        id: 2,
        chosen: 'يمسح',
        notChosen: 'يمسح',
        icon: <AppIcons.deleteIcon fill={'#000'} className={`moreBox`} />,
      },
      {
        id: 8,
        chosen: 'صامت',
        icon: (
          <AppIcons.muteIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'إلغاء كتم الصوت',
        notchosenIcon: (
          <AppIcons.unMuteIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
      },
      {
        id: 3,
        chosen: 'حاجز',
        icon: <AppIcons.BlockIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'رفع الحظر',
      },
      {
        id: 4,
        chosen: 'يحرر',
        icon: (
          <AppIcons.EditIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'يحرر',
      },
      {
        id: 5,
        chosen: 'غادر المجموعة',
        icon: (
          <ToolbarIcons.ExitIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'غادر المجموعة',
      },
      {
        id: 6,
        chosen: 'أعضاء المجموعة',
        icon: <AppIcons.GroupIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'أعضاء المجموعة',
      },
      {
        id: 7,
        chosen: 'إزالة التاريخ',
        icon: <AppIcons.ClearHistoryIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'إزالة التاريخ',
      },
      // { id: 3, text: 'يشارك', icon: <AppIcons.DownloadIcon /> },
    ],
  },
  setting: {
    more: [
      {
        id: 1,
        chosen: 'ملف',
        icon: (
          <ToolbarIcons.FileIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 5,
        chosen: 'تعديل الملف الشخصي',
        icon: (
          <ToolbarIcons.EditProfileIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 3,
        chosen: 'إعدادات',
        icon: (
          <ToolbarIcons.SettingsIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 4,
        chosen: 'إنشاء مجموعة',
        icon: (
          <AppIcons.GroupIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
          />
        ),
      },
      {
        id: 2,
        chosen: 'مخرج',
        icon: (
          <ToolbarIcons.ExitIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
    ],
  },
  footerMoreBox: [
    { id: 1, name: 'مشاركة المستخدم', icon: <AppIcons.userShareIcon /> },
  ],
  personalInfoModal: {
    title: 'اسم',
    username: 'اسم المستخدم',
    groupname: 'أسم المجموعة',
    description: 'وصف',
    users: 'المستخدمين',
    submit: 'إرسال ',
    edit: 'تحرير ',
    delete: 'حذف',
    placeholder: 'اكتب هنا...',
    introTitleAdd: 'إضافة أشخاص إلى المجموعة',
    introTextAdd: 'أضف أشخاصًا إلى المجموعة وتواصل معهم.',
    introTitleEdit: 'تحرير المجموعة',
    introTextEdit: 'تعديل الاسم والصورة وأعضاء المجموعة والملاحظات.',
  },
  group: {
    createGroup: 'إنشاء مجموعة',
    editGroup: 'تحرير المجموعة',
  },
  noInfoFound: 'لم يتم العثور على معلومات!',
  shareUserHeader: 'مشاركة المستخدم',
  forwardHeader: 'ارسل إلى',
  newMessage: 'رسالة جديدة',
  newFile: 'ملف جديد',
  countryCode: {
    error: 'بلدك غير مدعوم',
    code: 'الرقم',
    placeholder: '۹۸',
  },
  signup: {
    mobile: {
      title: 'الخطوة 1 / 2: أدخل رقم الهاتف المحمول',
      description: 'أدخل رقم هاتفك المحمول للتسجيل.',
      button: 'يكمل',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx ',
        title: ' تليفون محمول ',
        error: 'الهاتف المحمول غير صحيح',
      },
    },
    code: {
      title: 'الخطوة 2 / 2: أدخل رمز التحقق',
      description: 'أدخل الرمز المرسل إلى هاتفك المحمول.',
      button: 'يكمل',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx ',
        title: 'رمز التقديم',
        error: 'أدخل الرمز المستلم كرقم مكون من أربعة أرقام.',
      },
      resend: ' أعد إرسال الرمز',
    },
    success: {
      title: 'تهانينا.',
      description: 'اكتمل تسجيلك. مرحباً. ',
      button: 'يدخل',
    },
  },
  forgetPassword: {
    mobile: {
      title: 'الخطوة 1/2: أدخل رقم الهاتف المحمول',
      description: 'أدخل رقم هاتفك المحمول لتغيير كلمة المرور الخاصة بك.',
      button: 'يكمل',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx ',
        title: ' تليفون محمول ',
        error: 'الهاتف المحمول غير صحيح',
      },
    },
    code: {
      title: 'الخطوة 2/2: أدخل الرمز المرسل',
      description: 'أدخل الرمز المرسل إلى هاتفك المحمول.',
      button: 'يُقدِّم',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx ',
        title: 'رمز التقديم',
        error: 'أدخل الرمز المستلم كرقم مكون من أربعة أرقام.',
      },
    },
    success: {
      title: 'تم تغيير الرقم السري بنجاح.',
      description: 'تم إرسال كلمة المرور الجديدة إلى رقم هاتفك المحمول.',
      button: 'يدخل ',
    },
  },
  changePassword: {
    prePass: {
      title: 'كلمة المرور السابقة',
      error: 'أدخل كلمة المرور السابقة.',
    },
    newPass: {
      title: 'كلمة المرور الجديدة',
      error: 'أدخل كلمة المرور الجديدة.',
    },
    reNewPass: {
      title: 'كرر كلمة المرور الجديدة',
      error: 'أعد إدخال كلمة المرور الجديدة.',
    },
    notMatch: 'كلمة المرور وتأكيد كلمة المرور غير متطابقين.',
    submit: 'يُقدِّم',
  },
  haveAccount: {
    title: 'هل لديك حساب؟',
    button: 'تسجيل الدخول',
  },
  forwarded: 'الرسالة المعاد توجيهها',
  uploadVideo: {
    noFileUploaded: 'لم يتم تحميل أي ملف.',
    isUploading: 'جاري التحميل...',
    videoIsReady: 'الفيديو جاهز.',
    from: 'من',
    megaByte: 'ميغا بايت',
    proccessing: 'الفيديو قيد الإعداد',
    chooseCover: 'اختر صورة الغلاف',
    chooseCoverError: 'اختر صورة الغلاف',
    uploadImage: '  تحميل الصور',
    uploadedImage: '  تحميل الصور',
    empty: 'فارغ',
    creating: 'إنشاء',
    submit: 'يُقدِّم',
    videoForm: {
      titleInput: 'عنوان الفيديو (مطلوب)',
      titleError: 'هذه الخانة مطلوبه.',
      titlePlaceholder: 'أدخل عنوان الفيديو',
      contentInput: 'الوصف (مطلوب)',
      contentError: 'أدخل وصف الفيديو',
      contentPlaceholder: 'أدخل وصف الفيديو',
      tagTitle: ' إضافة علامة ',
      tagError: 'هذه الخانة مطلوبه.',
      tagPlaceholder: ' إضافة علامة ',
      tag: 'العلامات',
      addTag: 'يضيف',
    },
  },
};
export default ar;
